import { BaseQueryApi, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { DataFilterEndpointTags, EmpresaEndpointTags, EndpointTags, TaskEndpointTags, VendedorEndpointTags, VisitasEndpointTags } from "../api/utils";
import { setCredentials, logOut } from "../api/auth/authSlice"; 
import { RootState } from "./store";
import { AuthState } from "../types/auth";

type FetchBaseQueryResult<T> = {
  data?: T;
  error?: FetchBaseQueryError;
};

export const baseQuery = fetchBaseQuery({
    baseUrl: "",
    credentials: "include",
    prepareHeaders(headers, { getState }) {
        const state = getState() as RootState;
        const token = state.auth.token;

        if(token) { 
            headers.set("Authorization", `Bearer ${token}`);
        }

        return headers;
    },
});

export const baseQueryWithReauth = async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error?.status == 403 || result.error?.status == 401) {
        const refreshResult = await baseQuery("/api/auth/refresh-token", api, extraOptions) as FetchBaseQueryResult<AuthState>;

        if(refreshResult.data) {

            const user = (api.getState() as RootState).auth.user;

            api.dispatch(setCredentials({ token: refreshResult.data.token, user }));

            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logOut());
        }
    }

    return result;
}
const tagTypes = [
    // empresaApi tags
    EmpresaEndpointTags.GET_EMPRESAS,
    "ConfirmedDeal",
    "getEmpresaById",
    "getEmpresaInfoById",
    "calendarioEmpresas",
    EndpointTags.CONFIRMED_DEAL,
    // tarea
    TaskEndpointTags.GET_TASKS,
    TaskEndpointTags.GET_TASK_BY_ID,
    EndpointTags.UPDATE_TASK,
    // user
    "getUserById",
    // vendedor
    VendedorEndpointTags.GET_EQUIPOS_VENTAS,
    VendedorEndpointTags.GET_VENDEDOR_BY_ID,
    // visitas
    VisitasEndpointTags.GET_VISITA_BY_ID,
    // data filters
    DataFilterEndpointTags.GET_USERS_FOR_FILTER,
];

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    tagTypes: tagTypes,
    endpoints: (builder) => ({})
});